import { render } from "./VposLogin.vue?vue&type=template&id=2b35b0ab&scoped=true"
import script from "./VposLogin.vue?vue&type=script&lang=js"
export * from "./VposLogin.vue?vue&type=script&lang=js"

import "./VposLogin.vue?vue&type=style&index=0&id=2b35b0ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b35b0ab"]])

export default __exports__